import { render } from "./AddRecord.vue?vue&type=template&id=aeede384&scoped=true"
import script from "./AddRecord.vue?vue&type=script&lang=js"
export * from "./AddRecord.vue?vue&type=script&lang=js"

import "./AddRecord.vue?vue&type=style&index=0&id=aeede384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeede384"]])

export default __exports__